import get from 'lodash/get'

import {PRODUCTS_CATEGORIES_NAMES} from 'utils/const'

export default function getProductCategoryName(category) {
  return get(PRODUCTS_CATEGORIES_NAMES, category, null)
}
